export const defaultClassCodeObject = {
    code: null,
    description: null,
    fullTime: null,
    partTime: null,
    annualPayroll: null,
    locNumber: null,
};

export const driversClassCodeObject = {
    code: '7219',
    description: 'Drivers',
    fullTime: null,
    partTime: null,
    annualPayroll: null,
    locNumber: null,
};

export const clericalClassCodeObject = {
    code: '8810',
    description: 'Clerical',
    fullTime: null,
    partTime: null,
    annualPayroll: null,
    locNumber: null,
};

export default {
    desiredEffDate: null,
    desiredExpDate: null,
    employersLiability: {
        eachAccident: '$1,000,000',
        diseasePolicyLimit: '$1,000,000',
        diseaseEachEmployee: '$1,000,000',
    },
    classCodes: [driversClassCodeObject, clericalClassCodeObject]
};
  